import { useSnackbar, type VariantType } from 'notistack';
import { useCallback } from 'react';

/**
 * Wrapper sobre notistack con API semántica. Portado del repo legacy SW-310
 * para que SW-330+331+332 (opportunities/talents/comments) lo consuman directo.
 *
 *   const notify = useNotify();
 *   notify.error('Domain not whitelisted');
 *   notify.success('Profile saved');
 *
 * Mounting: requiere `<SnackbarProvider>` en main.tsx (lo agregamos junto con esto).
 */
export function useNotify() {
  const { enqueueSnackbar } = useSnackbar();

  const make = useCallback(
    (variant: VariantType) => (message: string, opts?: { persist?: boolean }) =>
      enqueueSnackbar(message, {
        variant,
        autoHideDuration: opts?.persist ? null : variantDuration(variant),
      }),
    [enqueueSnackbar],
  );

  return {
    success: make('success'),
    error: make('error'),
    warning: make('warning'),
    info: make('info'),
    default: make('default'),
  };
}

function variantDuration(variant: VariantType): number {
  switch (variant) {
    case 'error':
      return 6_000;
    case 'warning':
      return 5_000;
    default:
      return 3_000;
  }
}
